export const pipesI18NDe = {
    today: "Heute",
    yesterday: "Gestern",
};
